<template>
  <div>
    {{value | DateWithMinutes | NoEmpty}}
    <v-btn icon @click="handleShowForm">
      <v-icon icon>fa-pencil-alt</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800">
      <v-card>
        <v-card-title class="headline">Override receipt material date</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <date-time-input
              label="Date"
              v-model="newValue"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm" :loading="requestInProgress">Cancel</v-btn>
          <v-btn @click="handleFormSubmit" :disabled="!submitEnabled" :loading="requestInProgress">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import DateTimeInput from '../Ui/DateTimeInput'
    import DateWithMinutes from '../Filters/DateWithMinutes';
    import NoEmpty from '../Filters/NoEmpty';
    import {caseService, notificationService} from "../../application";

    export default {
        name: 'overridden-receipt-materials-datetime-input',
        components: {
            DateTimeInput
        },
        filters: {
            DateWithMinutes,
            NoEmpty
        },
        props: {
            caseId: {
                value: String,
                required: true
            },
            originalValue: {
                value: String,
                required: true
            },
            value: {
                value: String,
                required: true
            },
        },
        data() {
            return {
                showModal: false,
                newValue: this.value,
                requestInProgress: false
            }
        },
        computed: {
            submitEnabled() {
                return this.value !== this.newValue
            }
        },
        methods: {
            handleShowForm() {
                this.showModal = true
            },
            handleHideForm() {
                this.showModal = false
            },
            handleFormSubmit() {
                if (this.requestInProgress) {
                    return
                }

                if (!this.$refs.form.validate()) {
                    return
                }

                let requested = {
                    caseId: this.caseId,
                    overriddenReceiptMaterialsDatetime: this.newValue
                };

                caseService.updateCaseOverrideInfo(requested)
                    .then(() => {
                        notificationService.success('Changes saved');
                        this.showModal = false;
                        this.$emit('input', this.newValue) // propagate changes to model
                    })
                    .catch(e => {
                        notificationService.error('Can\'t perform operation');
                        throw e
                    })
                    .finally(() => {
                        this.requestInProgress = false;
                    });

                this.requestInProgress = true;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/case/OverriddenReceiptMaterialsDatetimeInput.vue